import React, { useEffect, useState } from "react";
import { Card, Row, Col, Switch, Button, Space, Flex, Form } from "antd";
import { useTranslation } from "react-i18next";
import FormSwitch from "components/form/FormProvide/FormSwitch";
import FormAntd from "components/form/FormProvide/FormAntd";

function Beleave({
  initialValues = {},
  editBeleave = () => { }
}) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [isChange, setIsChange] = useState(false);

  useEffect(() => {
    form.setFieldsValue(initialValues);
  }, [initialValues, form]);

  const onFinish = (values) => {
    editBeleave(values);
  };

  return (
    <FormAntd
      form={form}
      initialValues={initialValues}
      onFinish={onFinish}
    >
      <Row justify="space-between" align="middle">
        <Col>
          <h2 style={{ color: "#313131", fontWeight: 600 }}>
            {t("configBesmart.be_Leave")}
          </h2>
          <span style={{ color: "#667085" }}>
            {t("configBesmart.document_Request_Management")}
          </span>
        </Col>
        <FormSwitch name="menuCodeBeleave" />
      </Row>

      <div style={{ marginTop: 24 }}></div>
      <Card
        style={{
          border: "1px solid #EAECF0",
          borderRadius: 10,
          background: "#ffffff",
        }}
      >
        <div style={{ padding: 18, borderBottom: "1px solid #F2F4F7", position: "relative", }} >
          <span style={{ color: "#667085", fontWeight: 600 }}>
            {t("leave.header")}
          </span>
          <div style={{ color: "#A2A1A8" }}>
            {t("configBesmart.leave_Request")}
          </div>

          <div style={{ position: "absolute", right: 20, top: 25 }}>
            <FormSwitch name="switchleaverequest" />
          </div>
        </div>

        <div style={{ padding: 18, borderBottom: "1px solid #F2F4F7", position: "relative", }} >
          <span style={{ color: "#667085", fontWeight: 600 }}>
            {t("ot_request")}
          </span>
          <div style={{ color: "#A2A1A8" }}>
            {t("configBesmart.overtime_Request")}
          </div>

          <div style={{ position: "absolute", right: 20, top: 25 }}>
            <FormSwitch name="switchovertime" />
          </div>
        </div>


        <div style={{ padding: 18, borderBottom: "1px solid #F2F4F7", position: "relative", }} >
          <span style={{ color: "#667085", fontWeight: 600 }}>
            {t("configBesmart.working_Outside_location")}
          </span>
          <div style={{ color: "#A2A1A8" }}>
            {t("configBesmart.offsite_Request")}
          </div>

          <div style={{ position: "absolute", right: 20, top: 25 }}>
            <FormSwitch name="switchoutside" />
          </div>
        </div>

        <div style={{ padding: 18, position: "relative" }}>
          <span style={{ color: "#667085", fontWeight: 600 }}>
            {t("endorse_time.header")}
          </span>
          <div style={{ color: "#A2A1A8" }}>
            {t("configBesmart.endorse_time_request")}
          </div>

          <div style={{ position: "absolute", right: 20, top: 25 }}>
            <FormSwitch name="switchtimerequest" />
          </div>
        </div>
      </Card>

      <Row justify="end" style={{ marginTop: 60 }}>
        <Space size={12}>
          <Button type="default" size="large" style={{ borderRadius: 8 }}>
            {t("common.cancel").toUpperCase()}
          </Button>

          <Button
            type="primary"
            size="large"
            htmlType="submit"
            style={{
              borderRadius: 8,
              backgroundColor: "var(--button-color)",
            }}
          >
            {t("confirm").toUpperCase()}
          </Button>
        </Space>
      </Row>
    </FormAntd>
  );
}

export default Beleave;